// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 26) return "./default/chunk-html-box-reg-wall.42c23307ebf4c84b9b41.js";
	if (chunkId === 36) return "./default/chunk-recombee-init.e723af47657e03b8b98c.js";
	if (chunkId === 27) return "./default/chunk-lazyload-images.a9f4370ec26d91728c36.js";
	if (chunkId === 24) return "./default/chunk-gtm-highlight.bbe7d0958ccb580991ea.js";
	if (chunkId === 34) return "./default/chunk-progressBar.f9bea0aec43cc1a988c5.js";
	if (chunkId === 16) return "./default/chunk-accordion.468b3abfa6d15d9019e7.js";
	if (chunkId === 21) return "./default/chunk-fadeInOnEnterViewport.79f8da9a5fcae3c85643.js";
	if (chunkId === 30) return "./default/chunk-megamenu.dc377f54310eb70440ca.js";
	if (chunkId === 25) return "./default/chunk-header.3652c82029a4e13d9c4b.js";
	if (chunkId === 29) return "./default/chunk-mainNavigation.f3f6de6ccd417232e4ae.js";
	if (chunkId === 31) return "./default/chunk-modal.bf0bd06f0488044c8fa8.js";
	if (chunkId === 68) return "./68.8e005a361892e6ca43c6.js";
	if (chunkId === 23) return "./default/chunk-gallery.a0240e4bc4a94c288c26.js";
	if (chunkId === 20) return "./default/chunk-enquiry.052d7bf476981e372ce2.js";
	if (chunkId === 40) return "./default/chunk-survey.9174d0f7241c0aa8463d.js";
	if (chunkId === 22) return "./default/chunk-forum.46579c3fccc51d039c5a.js";
	if (chunkId === 64) return "./64.f3aeedb294d83c03b15a.js";
	if (chunkId === 35) return "./default/chunk-recombee.74091428b36077ce021d.js";
	if (chunkId === 65) return "./65.82c63f61ee85d78b3b45.js";
	if (chunkId === 28) return "./default/chunk-load-more.75eb2b0f2247ba9c37e8.js";
	if (chunkId === 42) return "./default/chunk-uncover-behav-articles.27d87bc6750190234c57.js";
	if (chunkId === 17) return "./default/chunk-ads-repeater.29d96dc61ed087cc6b49.js";
	if (chunkId === 49) return "./default/newsletter.89d5936bc0fcbb05042b.js";
	if (chunkId === 44) return "./default/companySubscription.57e8cd554bf4b180116a.js";
	if (chunkId === 53) return "./default/swiper.12bb9ab4bae19a51e36d.js";
	if (chunkId === 55) return "./default/thingsArticleSwiper.5f6375df2cb6e133d56a.js";
	if (chunkId === 19) return "./default/chunk-editorial-promo.c0c2957741382a3c7e20.js";
	if (chunkId === 56) return "./default/topic-banner.a668146c044a359560b0.js";
	if (chunkId === 47) return "./default/instagram.9f60b184bb332e0fa47d.js";
	if (chunkId === 50) return "./default/piano.467b1de6e5e20843cd1e.js";
	if (chunkId === 66) return "./66.05a735be8ed4b389dec0.js";
	if (chunkId === 51) return "./default/portaInit.37e2eedab4156adb281e.js";
	if (chunkId === 48) return "./default/jakebox.698e91ffdeb3fbc0d17a.js";
	if (chunkId === 43) return "./default/collapser.199265f4af13959b048f.js";
	if (chunkId === 15) return "./default/author-card-list.0baf715f1a0d00714494.js";
	if (chunkId === 52) return "./default/rename-article-list.af91603ad9581ac121d0.js";
	if (chunkId === 13) return "./chunk-todayResultSliderHP.171c810e9c5cbabcf477.js";
	if (chunkId === 7) return "./chunk-previewMatchesListVideoSlider.d79694757a2e6d487525.js";
	if (chunkId === 5) return "./chunk-headermenuflat.80287d405667c82298a8.js";
	if (chunkId === 46) return "./default/info-toggle.5e6f90380b39b3197901.js";
	if (chunkId === 54) return "./default/tabs.b8b6bb16ffe953b98b35.js";
	if (chunkId === 12) return "./chunk-sportmodDayResultDatepicker.2d77e0d74498bab7cc4d.js";
	if (chunkId === 67) return "./67.0f1391912e9243f54998.js";
	if (chunkId === 9) return "./chunk-sportmod-live-match-websocket-updater.36337cb07eca4c0ee20c.js";
	if (chunkId === 8) return "./chunk-sportmod-league-phase-reloader.d5ca63f6d0a138c56158.js";
	if (chunkId === 10) return "./chunk-sportmod-matches-with-table-phase-reloader.59fa13d33ff4b21739b1.js";
	if (chunkId === 11) return "./chunk-sportmod-team-matches-toggle.89dd589bdd18162cc8e8.js";
	if (chunkId === 4) return "./chunk-category-content-loader.46f2fd31a659a4b8ef74.js";
	if (chunkId === 14) return "./chunk-top-feed-responsive-behavior.ff523ebbc8f9e31b19d9.js";
	// return url for filenames based on template
	return undefined;
};